import { render, staticRenderFns } from "./ibcExamination_set_score.vue?vue&type=template&id=28b4916b&scoped=true&"
import script from "./ibcExamination_set_score.vue?vue&type=script&lang=js&"
export * from "./ibcExamination_set_score.vue?vue&type=script&lang=js&"
import style0 from "./ibcExamination_set_score.vue?vue&type=style&index=0&id=28b4916b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b4916b",
  null
  
)

export default component.exports